import './style.sass';

import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import Image from 'next/image';

type FrontendItem = {
    text: string;
    title: string;
};

type LayoutPageProps = {
    listFrontend: FrontendItem[];
};
const Business = ({ listFrontend }: LayoutPageProps) => {
    return (
        <div>
            <div className="skills-business">
                <FullWrapper isMargin={false}>
                    <div className="skills-businessWrapper">
                        <div className="skills-businessTitle">
                            Какие бизнес-задачи решает SkillsTeam
                        </div>
                        <div className="skills-businessInner">
                            <div className="skills-businessLeft">
                                <div className="skills-businessLeftList">
                                    {listFrontend.map((item, index) => (
                                        <div className="skills-businessLeftItem" key={index}>
                                            <div
                                                className="skills-businessLeftTitle"
                                                dangerouslySetInnerHTML={{ __html: item.title }}
                                            ></div>
                                            <div
                                                className="skills-businessLeftText"
                                                dangerouslySetInnerHTML={{ __html: item.text }}
                                            ></div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </FullWrapper>
            </div>
            <div className="skills-business">
                <FullWrapper isMargin={false}>
                    <div className="skills-businessWrapper">
                        <div className="skills-businessTitle">
                            Версии продукта: коробочная и&nbsp;облачная
                        </div>
                        <div className="skills-businessInner">
                            <div className="skills-businessLeft">
                                <div className="skills-businessDescription">
                                    В&nbsp;системе есть облачное решение и&nbsp;коробочная версия
                                    для корпораций. Облачная версия идеально подходит для небольших
                                    командам, которые хотят автоматизировать управление грейдами без
                                    сложных интеграций. Для корпораций мы&nbsp;разработали
                                    коробочную версию, которая устанавливается во&nbsp;внутренний
                                    ИТ-контур компании. Такое решение обеспечивает безопасность
                                    данных и&nbsp;позволяет легко интегрироваться
                                    с&nbsp;существующими HR-системами, обеспечивая синхронизацию
                                    всех процессов внутри организации.
                                </div>
                            </div>
                            <div className="skills-businessRight">
                                <div className="skills-businessRightText">
                                    Компании могут загрузить свои собственные компетенции
                                    и&nbsp;грейды, адаптируя систему под потребности бизнеса.
                                </div>
                                <div className="skills-businessRightPlay">
                                    <Image
                                        src="/images/pic/skills-team/play.svg"
                                        alt="play"
                                        width={24}
                                        height={28}
                                    />
                                    <a
                                        className="skills-businessRightLink"
                                        href="https://kinescope.io/oxqUS1MRA5a66TotCHY5DY"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        Демо-версия базового продукта
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </FullWrapper>
            </div>
            <div className="skills-business">
                <FullWrapper isMargin={false}>
                    <div className="skills-businessWrapper">
                        <div className="skills-businessTitle">Консалтинг</div>
                        <div className="skills-businessInner">
                            <div className="skills-businessLeft">
                                <div className="skills-businessDescription">
                                    При внедрении SkillsTeam и&nbsp;работе с&nbsp;клиентами
                                    столкнулись с&nbsp;тем, что во&nbsp;многих компаниях матрицы
                                    компетенций требуют актуализации, а&nbsp;внутренних ресурсов
                                    на&nbsp;это нет. В&nbsp;результате, матрицы перестают отражать
                                    реальные потребности бизнеса и&nbsp;не&nbsp;позволяют эффективно
                                    оценивать потенциал сотрудников.
                                </div>
                                <div className="skills-businessDescription">
                                    Для решения этой задачи создали институт методистов
                                    и&nbsp;разработали методологию, как автоматизировать процесс.
                                    Наши консультанты помогают структурировать знания
                                    и&nbsp;внедрить систему управления грейдами, соответствующую
                                    бизнес-задачам внутри любой компании, независимо
                                    от&nbsp;ее&nbsp;масштаба и&nbsp;сферы деятельности. Это
                                    позволяет освободить время вашей команды для стратегических
                                    задач.
                                </div>
                                <div className="skills-businessDescription">
                                    Есть несколько вариантов консалтинговой поддержки:
                                    от&nbsp;адаптации под свою структуру базовых матриц
                                    из&nbsp;библиотеки SkillsTeam до&nbsp;разработки индивидуальной
                                    матрицы компетенций с&nbsp;глубокой персонализацией для каждой
                                    роли, учитывающей специфику бизнеса. В&nbsp;итоге компания
                                    получает сформированную систему грейдов на&nbsp;платформе
                                    SkillsTeam, методологическое пособие по&nbsp;их&nbsp;управлению,
                                    а&nbsp;также обучение сотрудников для дальнейшей самостоятельной
                                    работы с&nbsp;системой.
                                </div>
                            </div>
                            <div className="skills-businessRight">
                                <div className="skills-businessRightText">
                                    Методисты берут на&nbsp;себя сложные аналитические задачи:
                                    от&nbsp;сбора данных до&nbsp;формирования структуры матриц. Это
                                    позволяет HR-функции сосредоточиться на&nbsp;стратегических
                                    задачах и&nbsp;работе с&nbsp;персоналом.
                                </div>
                            </div>
                        </div>
                    </div>
                </FullWrapper>
            </div>
            <div className="skills-businessFront">
                <FullWrapper isMargin={false}>
                    <div className="skills-businessFrontWrapper">
                        <div className="skills-businessBlock">
                            <div className="skills-businessFrontContent">
                                <div className="skills-businessFrontTitle">
                                    Frontend-разработчик
                                </div>
                            </div>
                            <div className="skills-businessFrontItem">
                                <Image
                                    src="/images/pic/skills-team/skillsTb.png"
                                    alt="cloud system"
                                    width={1402}
                                    height={636}
                                    className="skills-businessFrontImg"
                                />
                            </div>
                        </div>
                    </div>
                </FullWrapper>
            </div>
        </div>
    );
};

export default Business;
